// extracted by mini-css-extract-plugin
module.exports = {"page":"Settings_page__Rytvv","topBar":"Settings_topBar__F3wYt"};